import axios from 'axios';
import React, { useState, useRef, useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import BACKEND_URL from '../../api';
import banner from '../../images/banners/login.jpg'

export default function AwblabelAramex() {
  let newDate = new Date()
  let date = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();
  const today = `${year}/${month}/${date}`
  const [parcelcount, setparcelcount] = useState(1)
  const location = useLocation();
  const [order, setorder] = useState('')
  const [parcelcontent, setparcelcontent] = useState('')
  const [orderdata, setorderdata] = useState(false)

  useEffect(() => {
    if (order == "") {
      axios({
        method: 'post',
        url: `${BACKEND_URL}/getOrderDetails`,
        data: { orderid: location.state.orderno }
      })
        .then((res) => {
          console.log("getOrderDetails------------", res.data, location)
          if (res.data != "") {
            setorderdata(true);

            setorder(JSON.parse(JSON.stringify(res.data)))
            if (res.data.parcel != "") {
              setparcelcontent(res.data.parcel)
              setparcelcount(res.data.parcel.length)
            }

            Afterdata(res.data.collectiondetails.email, res.data.orderdetails.total_price)
          }
        })
        .catch((err) => console.log(err))
    } else {

    }
  }, [])


  const ref = useRef();
  const ref1 = useRef();

  function Afterdata(emailid, total_price1) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'purchase_confirmed',
      'order_value': total_price1,
      'order_id': location.state.orderno,
      'email': emailid
    });


  }

  return (
    <div class="awblabel ">
      <Helmet>
        <title>Shypv | Order Confirmation</title>
      </Helmet>
      <section className="your_business_page fw" style={{ backgroundImage: `url(${banner})`, backgroundAttachment: 'fixed', backgroundSize: 'cover' }}>
        <div className="container"><div className="row">
          <div className="col-md-12 col-sm-12 your_business text-center">
            <div className="business_content">
              <h1 className='h1-title'>ORDER DETAIL</h1>

            </div>
          </div>
        </div>
        </div>
      </section>

      <style type="text/css" media="print" dangerouslySetInnerHTML={{ __html: "\n  @page { size: landscape; }\n   @page { margin: 0; size: A4;}\n   @media print {\n  footer {\n    position: fixed;\n    bottom: 0;\n  }\n\n  .content-block, p {\n    page-break-inside: avoid;\n  }\n\n  html, body {\n    width: 210mm;\n    height: 297mm;\n  }\n}\n" }} />

      <div className=" parsel_container pages_content" >
        <p className="received_text" style={{ textAlign: 'left' }}>
          Please print the label and attach to your package, our driver will come shortly to collect your parcel. A PDF copy of your label is also available to download from your confirmation email.</p>

        {
          location.state.awbdetail.Aramex_label ? (
            <p className="received_text" style={{ textAlign: 'left' }}><a href={location.state.awbdetail.Aramex_label} download="Label" target="_blank">Download / Print Label </a></p>

          ) : null
        }
        <div className="servies-content become_driver last_order thank-you-page">
          {location.state.awbdetail.Aramex_label ? (
            //  <iframe src={location.state.awbdetail.Aramex_label} style={{width: "100%",height: "600px",border:"none"}}></iframe>
            <div className="table-responsive " ref={ref}>
              <embed src={`${location.state.awbdetail.Aramex_label}#toolbar=0`} style={{ width: "100%", height: "600px", border: "none" }}></embed>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}
